import { useSelector } from 'react-redux';

import httpService from 'services/HttpService';
import { generateURLRappiServices } from 'shared/utils/urls';

import { MENU_PAGE_PATH } from './menuPage.const';

import type {
  BaseRouteParams,
  TurnOffCustomizationReq,
  TurnOffProductReq,
  TurnOnCustomizationReq,
  TurnOnProductReq,
} from './menuPage.request';
import type {
  FullMenuCatalogRawResp,
  OutOfStockRawResp,
} from './menuPage.response';
import type { Store } from 'shared/domain';

function readStoresByProfile(): Store[] {
  const profile = useSelector<any, any>(s => s.partnerReducer.profile);
  return profile.stores.map((s: any) => ({ id: s.id, name: s.name }));
}

function readFullMenuCatalog(params: BaseRouteParams) {
  const { storeId } = params;
  return httpService.get<FullMenuCatalogRawResp>(
    generateURLRappiServices({
      url: MENU_PAGE_PATH.FULL_MENU,
      pathParams: { storeId },
    }),
  );
}

function readOutOfStock(params: BaseRouteParams) {
  const { storeId } = params;
  return httpService.get<OutOfStockRawResp>(
    generateURLRappiServices({
      url: MENU_PAGE_PATH.OUT_OF_STOCK_ITEMS,
      pathParams: { storeId },
    }),
  );
}

function updateTurnOnProduct(params: TurnOnProductReq) {
  const { payload } = params;
  return httpService.put<never>(
    generateURLRappiServices({ url: MENU_PAGE_PATH.TURN_ON_PRODUCT }),
    payload,
  );
}

function updateTurnOffProduct(params: TurnOffProductReq) {
  const { payload } = params;
  return httpService.put<never>(
    generateURLRappiServices({ url: MENU_PAGE_PATH.TURN_OFF_PRODUCT }),
    payload,
  );
}

function updateTurnOnCustomization(params: TurnOnCustomizationReq) {
  const { payload } = params;
  return httpService.put<never>(
    generateURLRappiServices({ url: MENU_PAGE_PATH.TURN_ON_CUSTOMIZATION }),
    payload,
  );
}

function updateTurnOffCustomization(params: TurnOffCustomizationReq) {
  const { payload } = params;
  return httpService.put<never>(
    generateURLRappiServices({ url: MENU_PAGE_PATH.TURN_OFF_CUSTOMIZATION }),
    payload,
  );
}

function updateTurnOffCustomizationList(params: TurnOffCustomizationReq) {
  const { payload } = params;
  return httpService.put<never>(
    generateURLRappiServices({
      url: MENU_PAGE_PATH.TURN_OFF_CUSTOMIZATION_LIST,
    }),
    payload,
  );
}

export const menuPageRepository = {
  readStoresByProfile,
  readFullMenuCatalog,
  readOutOfStock,
  updateTurnOnProduct,
  updateTurnOffProduct,
  updateTurnOnCustomization,
  updateTurnOffCustomization,
  updateTurnOffCustomizationList,
} as const;
